import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TopComponent } from './top/top.component';
import { DashboadComponent } from './dashboad/dashboad.component';

const routes: Routes = [
  { path: '', component: TopComponent  },
  { path: 'dashboad', component: DashboadComponent  },
  // { path: 'new', component:  },
  ];

@NgModule({
  imports: [
    RouterModule.forRoot(routes)
  ],
  exports: [RouterModule],
  declarations: []
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// C:/Users/homePC/angular-comp/yarukami/src/app/app-routing.module.ts